import CustomElement from "./CustomElement";

export default class SlideWithColumns extends CustomElement {

	constructor() {
		super();

		this.style.setProperty('--cols', this.querySelectorAll('.block-slide-column').length);
	}
}
